import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import React from "react";
import InversionCapitalTrabajo from "../../components/Inversion/InversionCapitalTrabajo";

function InversionCapitalTrabajoPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <InversionCapitalTrabajo ciemId={ciemId}/>
        </div>
    );
}

export default InversionCapitalTrabajoPage;